import type { FileInfo } from "@exagens/behavioral-insight-console-client";
import type { SparxsBlueprintCacheEntry } from "@/store/sparxsCatalog/blueprintCacheSlice";
import { isCatalogFileNewerThanStoredListVersion } from "@/features/sparxsEditor/lib/catalog/catalogFingerprint";

export const shouldRefetchBlueprintFromServer = (
  file: FileInfo | undefined,
  cache: SparxsBlueprintCacheEntry | undefined,
): boolean => {
  if (cache == null) {
    return true;
  }
  if (file == null) {
    return false;
  }
  return isCatalogFileNewerThanStoredListVersion(file, cache.listLastModified);
};
